export interface PermissionsInfo {
    name: string;

    description: string;
}

export const NONE: PermissionsInfo = { name: "None", description: "None" };
